module.exports = __webpack_public_path__ + "static/5-747adf2eab5e0128b3e6baee193f481f.png";